import { axiosInstance as axios } from '../../boot/axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    GetCaseList({ rootGetters }, request) {
      return axios
        .post('OemCaseTracking/GetCaseList', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得單一案件資料(T134)
    GetOemT134ByID({ rootGetters }, request) {
      return axios
        .get(`OemCaseTracking/GetOemT134ByID?OemOrderID=${request.OemOrderID}`)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得單一案件資料(T2)
    GetOemT2ByID({ rootGetters }, request) {
      return axios
        .get(`OemCaseTracking/GetOemT2ByID?OemOrderID=${request.OemOrderID}`)
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 取得單一案件資料(軟體)
    GetOemSoftByID({ rootGetters }, request) {
      return axios
        .get(`OemCaseTracking/GetOemSoftByID?OemOrderID=${request.OemOrderID}`)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    // 是否可領取門店訂單
    IsAbleTakeQuick({ commit, rootGetters }, request) {
      return axios
        .get('OemCaseTracking/IsAbleTakeQuick', { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOemT134({ rootGetters }, request) {
      return axios
        .post('OemCaseTracking/AddOemT134', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddOemT2({ rootGetters }, request) {
      return axios
        .post('OemCaseTracking/AddOemT2', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    AddCaseSoft({ rootGetters }, request) {
      return axios
        .post('OemCaseTracking/AddCaseSoft', {
          ...request
        })
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOemT134({ rootGetters }, request) {
      return axios
        .put('OemCaseTracking/UpdateOemT134', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UpdateOemT2({ rootGetters }, request) {
      return axios
        .put('OemCaseTracking/UpdateOemT2', {
          ...request
        })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    EditCaseSoft({ rootGetters }, request) {
      return axios
        .put('OemCaseTracking/EditCaseSoft', {
          ...request
        })
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetMajorCabinetNo({ rootGetters }, request) {
      return axios
        .get(`OemCaseTracking/GetMajorCabinetNo?CaseID=${request.CaseID}`)
        .then((response) => {
          if (response.data.Status) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetOemT1234PerformByCase({ rootGetters }, request) {
      return axios
        .post(
          'OemCaseTracking/GetOemT1234PerformByCase',
          {
            ...request
          },
          { timeout: 60000 }
        )
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          if (error.code === 'ECONNABORTED') {
            return Promise.reject('請求逾時，請稍後再重新嘗試')
          } else {
            return Promise.reject(error)
          }
        })
    },

    GetCasePerformByMonth({ rootGetters }, request) {
      return axios
        .post(
          'OemCaseTracking/GetCasePerformByMonth',
          {
            ...request
          },
          { timeout: 60000 }
        )
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.errorInfo)
          }
        })
        .catch((error) => {
          if (error.code === 'ECONNABORTED') {
            return Promise.reject('請求逾時，請稍後再重新嘗試')
          } else {
            return Promise.reject(error)
          }
        })
    },
    UpdateOemCaseClosure({ commit, rootGetters }, request) {
      return axios
        .put('OemCaseTracking/UpdateOemCaseClosure', null, { params: request })
        .then((response) => {
          if (response.data.Values.ReqInt === 0) {
            return Promise.resolve(response.data.Values)
          } else if (response.data.Values.ReqInt === -1) {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    DownloadPerformMonthDetail({ commit, rootGetters }, request) {
      return axios
        .post('OemCaseTracking/DownloadPerformMonthDetail', { ...request }, { responseType: 'blob' })
        .then(async (response) => {
          // 透過blob.type判斷是否為stream，若否則將 blob 轉為 JSON
          const blob = response.data
          if (blob.type === 'application/json') {
            const text = await blob.text()
            const json = JSON.parse(text)

            if (json?.Values?.ReqInt === -1) {
              return Promise.reject(json?.Values?.errorInfo)
            } else {
              return Promise.reject('發生錯誤')
            }
          } else {
            return Promise.resolve(response.data)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    }
  }
}
